import React, { useEffect, useState } from 'react'
import Table from '../../components/Table';
import BarChart from '../../components/chartTypes/Barchart';
import { Column } from 'react-table';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import { generatePortfolioMovementEMI, generatePortfolioSummaryEMI } from '../../services/summaryReportsEMI';
import { emiReportDate, sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { useTranslation } from 'react-i18next';
const PortfolioSummaryEMI = () => {

  const { t } = useTranslation();


  interface Order {
    period: string;
    active_loan_count: string;
    tot_princ_os_amt_formatted: string;
    princ_os_amt_per_account: string;
    // emiPortfolio: string;
  }

  interface OrderSummary {
    period:string;
    closure_amt_formatted: string;
    repayment_amt_formatted: string;
    new_origination_principal_os_formatted: string;
    net_movement_formatted: string;
  }
    const [portfolioSummary, setPortfolioSummary] = useState<any[]>([]);
    const [portfolioMovement, setPortfolioMovement] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [portfolioMovemenLoading, setPortfolioMovemenLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

     

    const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
            periodWithOutDay: ["month"],
            fromDate: [sixMonthsAgoFormatted],
            toDate: [emiReportDate]
            }));

    const [applyFilter, setApplyFilter] = useState<boolean>(false);

    const handleFilterChange = (updatedValues: Record<string, string[]>) => {
        setSelectedFilters(updatedValues);
        };

    const handleCancelClick = () => {
        setSelectedFilters({
          periodWithOutDay: ["month"],
          fromDate: [sixMonthsAgoFormatted],
          toDate: [emiReportDate]
        })
        setApplyFilter(!applyFilter)
        }

    const filter = [
        { key: "state", type: "select", label: t("filters.state") },
        // { key: "territory", type: "select", label: t("filters.territory") },
        { key: "cluster", type: "select", label: t("filters.cluster") },
        { key: "branch", type: "select", label: t("filters.branch") },
        { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
        { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
        { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: emiReportDate },
      ];

  const columns: Column<any>[] = [
        { Header: "Period", accessor: "period" },
        { Header: "#Loans", accessor: "active_loan_count" },
        { Header: "PE O/S", accessor: "tot_princ_os_amt_formatted" },
        { Header: "PE O/S per account", accessor: "princ_os_amt_per_account" },
        // { Header: "EMI Loans % portfolio", accessor: "emiPortfolio" },
  ];

  const NetMovementColumns: Column<OrderSummary>[] = [
    { Header: "Period", accessor: "period" },
    { Header: "Closures(A)", accessor: "closure_amt_formatted" },
    { Header: "Repayments(B)", accessor: "repayment_amt_formatted" },
    { Header: "New Origination PE O/S (C)", accessor: "new_origination_principal_os_formatted" },
    { Header: "Net Movement (C-B-A)", accessor: "net_movement_formatted" },
  ];

 const generatePortfolioSummaryApi = async () => {
  setLoading(true);
    try {
      const response = await generatePortfolioSummaryEMI(selectedFilters); // Call the API function
      setPortfolioSummary(response.data); // Update state with user data
    } catch (err) {
      setError("Failed to fetch users");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const generatePortfolioNetMovement= async () => {
    setPortfolioMovemenLoading(true);
    try {
      const response = await generatePortfolioMovementEMI(selectedFilters); // Call the API function
      setPortfolioMovement(response.data); // Update state with user data
    } catch (err) {
      setError("Failed to fetch users");
      console.error(err);
    } finally {
      setPortfolioMovemenLoading(false);
    }
  };

    useEffect(() => {
      generatePortfolioSummaryApi();
      generatePortfolioNetMovement();
    }, [applyFilter]);

  return (
    <div>
    {/* Page Content */}
    <div className="page-content">
      {/* Dynamic Grey Header */}
      <div className="header">
      {t('EMIReportsFolder.portfolioSummaryEMI.pageTitle')} 
      </div>

      {/* Main Content */}
      <div className="content px-3">
          <MultiSelectCheckboxGroup 
          filters={filter} 
          selectedValues={selectedFilters} 
          onChange={handleFilterChange} 
          isLoading={[loading, portfolioMovemenLoading]}
          buttons={[
            { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
            { label: t("buttons.cancel"), onClick: handleCancelClick },
            { label: t("buttons.download"), onClick: () => alert("Download triggered") },
          ]}
          />
      </div>

       
      {/* New Orgination # section */}
        <div className="p-3">
          <div style={{"width": "100%", "overflow": "scroll"}}>
          <Table 
              columns={columns} 
              data={portfolioSummary} 
              tableHead={t('EMIReportsFolder.portfolioSummaryEMI.tableHead1')}
              type="1"
              loading={loading}
          />
          </div>
        </div>

      {/* New Orgination # section */}
      <div className="p-3 mt-5">
                <div style={{"width": "100%", "overflow": "scroll"}}>
                <Table 
                    columns={NetMovementColumns} 
                    data={portfolioMovement} 
                    tableHead={t('EMIReportsFolder.portfolioSummaryEMI.tableHead2')}
                    type="1"
                    loading={portfolioMovemenLoading}
                />
                </div>
        </div>

      <div className="mt-5 p-5" style={{marginTop: "20px"}}>
        <BarChart 
          title={t('EMIReportsFolder.portfolioSummaryEMI.title')}
          labels={portfolioMovement.map(item => item.period)}
          dataSets={[
              { 
                  label: t('EMIReportsFolder.portfolioSummaryEMI.label'), 
                  // data: portfolioMovement.map(item => parseFloat(item.net_movement_formatted.replace(/K/g, '000'))), 
                  data: portfolioMovement.map(item => item.net_movement), 
                  backgroundColor: "grey" 
              }
          ]}
          xLabel={t('EMIReportsFolder.portfolioSummaryEMI.xLabel')}
          yLabel={t('EMIReportsFolder.portfolioSummaryEMI.yLabel')}
        />
        </div>


      </div>
    </div>
  )
}

export default PortfolioSummaryEMI;
